import type {
    MenuProps as _MenuProps,
    MenuButtonProps as _MenuButtonProps,
    MenuListProps as _MenuListProps,
    MenuItemProps as _MenuItemProps,
    MenuItemOptionProps as _MenuItemOptionProps,
    MenuGroupProps as _MenuGroupProps,
    MenuOptionGroupProps as _MenuOptionGroupProps,
    MenuDividerProps as _MenuDividerProps,
} from "@chakra-ui/react";
import {
    forwardRef,
    Menu as _Menu,
    MenuButton as _MenuButton,
    MenuList as _MenuList,
    MenuItem as _MenuItem,
    MenuItemOption as _MenuItemOption,
    MenuGroup as _MenuGroup,
    MenuOptionGroup as _MenuOptionGroup,
    MenuDivider as _MenuDivider,
    MenuIcon as _MenuIcon,
} from "@chakra-ui/react";

export interface MenuProps extends _MenuProps {}
export interface MenuButtonProps extends _MenuButtonProps {}
export interface MenuListProps extends _MenuListProps {}
export interface MenuItemProps extends _MenuItemProps {}
export interface MenuItemOptionProps extends _MenuItemOptionProps {}
export interface MenuGroupProps extends _MenuGroupProps {}
export interface MenuOptionGroupProps extends _MenuOptionGroupProps {}
export interface MenuDividerProps extends _MenuDividerProps {}

export const Menu: React.FC<MenuProps> = ({ children, ...props }) => (
    <_Menu isLazy {...props}>
        {children}
    </_Menu>
);

export const MenuButton = forwardRef<MenuButtonProps, "button">(({ ...props }, ref) => (
    <_MenuButton ref={ref} {...props} />
));

export const MenuList = forwardRef<MenuListProps, "div">(({ ...props }, ref) => (
    <_MenuList ref={ref} {...props} />
));

export const MenuItem = forwardRef<MenuItemProps, "button">(({ ...props }, ref) => (
    <_MenuItem ref={ref} {...props} />
));

export const MenuItemOption = forwardRef<MenuItemOptionProps, "div">(({ ...props }, ref) => (
    <_MenuItemOption ref={ref} {...props} />
));

export const MenuGroup = forwardRef<MenuGroupProps, "div">(({ ...props }, ref) => (
    <_MenuGroup ref={ref} {...props} />
));

export const MenuOptionGroup: React.FC<MenuOptionGroupProps> = (props) => (
    <_MenuOptionGroup {...props} />
);

export const MenuDivider: React.FC<MenuDividerProps> = (props) => <_MenuDivider {...props} />;

export const MenuIcon = forwardRef<any, "span">(({ ...props }, ref) => (
    <_MenuIcon ref={ref} {...props} />
));
